import instance from '../scorpiusInstance';
import {
  FETCH_ALL_PERMISSIONS_START,
  FETCH_ALL_PERMISSIONS_SUCCESS,
  FETCH_ALL_PERMISSIONS_ERROR,
} from '../types';

export const fetchAllPermissionsStart = (orgId, appName) => ({
  type: FETCH_ALL_PERMISSIONS_START,
  orgId,
  appName,
});

export const fetchAllPermissionsSuccess = (orgId, appName, permissions) => ({
  type: FETCH_ALL_PERMISSIONS_SUCCESS,
  orgId,
  appName,
  permissions,
});

export const fetchAllPermissionsFailed = (orgId, appName, error) => ({
  type: FETCH_ALL_PERMISSIONS_ERROR,
  orgId,
  appName,
  error,
});

/**
 * Fetch all available permission options for an organization's application.
 * @param {String} orgId - ID associated with the user's organization
 * @param {String} appName - name of the application
 */
export const fetchAllPermissions = (orgId, appName) => async dispatch => {
  dispatch(fetchAllPermissionsStart(orgId, appName));
  try {
    const response = await instance.get(
      `/organizations/${orgId}/${appName}/permissions`,
      { headers: { retry: true } },
    );
    return dispatch(fetchAllPermissionsSuccess(orgId, appName, response.data));

    // return dispatch(
    //   fetchAllPermissionsSuccess(orgId, appName, permissionsMock),
    // );
  } catch (error) {
    throw dispatch(fetchAllPermissionsFailed(orgId, appName, error));
  }
};

export default fetchAllPermissions;
